import React, { FC, useEffect, useState } from "react";
// import { Button, Form } from "antd";
import { Button, Form, message } from "antd";
import dayjs from "dayjs";
import EchsProcedureForm from "./EchsProcedureForm";
import AdmissionDetails from "./AdmissionDetails";
import BillDetails from "./BillDetails";
import AilmentDetails from "./AilmentDetails";
import DischargeDocumentUpload from "../../Discharge/IHX/IHXTabs/DischargeDocumentUpload";
import ResponseDischargeDocumentUpload from "../../Discharge/IHX/IHXTabs/ResponseDischargeDocumentUpload";
import DocumentUpload from "../../PreAuth/PreAuthEchs/DocumentUpload";
import ResponseDocumentUpload from "../../PreAuth/PreAuthEchs/ResponseDocumentUpload";
import { Spin } from "antd";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { ROUTES } from "../../../../utils/constants";
import { openBillAuditForMapping } from "../../../../utils/billAuditUrlUtils";
import { Link, useNavigate } from "react-router-dom";
import PatientDetails from "./PatientDetails";
import ReferralDetailsEchs from "./ReferralDetailsEchs";
import EchsExtraForm from "./EchsExtraForm";
import { Collapse } from "antd";
import EchsClaimClinicalFindings from "./EchsClaimClinicalFindings";
import EchsClaimLineOfTreatment from "./EchsClaimLineOfTreatment";
import { errorMessageModal } from "../../../../utils/modalMessage";
import { ClaimExtraDocument } from "../../../modals/BillRequiredDocumentModal";
import SupportingDocumentChecklistModal from "../../../modals/SupportingDocumentChecklistModal";

interface EchsClaimFormProps {
  claimData: any;
  procedureDropDown: any;
  isEditable: boolean;
  caseClaimSubmissionId: number | null;
  portalSubmission: boolean;
  handleDeleteProcedure?: any;
  form: any;
  loading: boolean;
  documentTypes: any[];
  documentUrls: any[];
  documentRequestResponseDocuments: any;
  handleFileChange: any;
  handleOpen: any;
  isApproved: boolean;
  handleSaveData: any;
  preAuth: any;
  activeKey: any;
  isIntimating: boolean;
  caseClaimId: any;
  isSubmitting: boolean;
  isSaving: boolean;
  handleSaveConfirmationModal: any;
  isApprovedInitiated: boolean;
  uploadFileList: any;
  setIsAmountModal: any;
  roomChargesOptions: any;
  consultationChargesOptions: any;
  implantListOptions: any;
  isFetchingRoomCharges: boolean;
  isFetchingConsultationCharges: boolean;
  isFetchingImplantList: boolean;
  billRequiredDocuments?: any[];
  claimExtraDocuments?: ClaimExtraDocument[];
  onSupportingFileSelect?: (
    doc: any,
    checkedItems: any[],
    file: File,
  ) => void;
  onViewSupportingDocument?: (record: any, documentUrl?: string) => void;
  onDownloadSupportingDocument?: (fileName: string, documentUrl: string) => void;
  onDeleteSupportingDocument?: (record: any, documentUrl?: string) => void;
}

const { Panel } = Collapse;

const EchsClaimForm: FC<EchsClaimFormProps> = ({
  claimData,
  procedureDropDown,
  isEditable,
  caseClaimSubmissionId,
  portalSubmission,
  handleDeleteProcedure,
  form,
  loading,
  documentTypes,
  documentUrls,
  documentRequestResponseDocuments,
  handleFileChange,
  handleOpen,
  isApproved,
  handleSaveData,
  preAuth,
  activeKey,
  isIntimating,
  caseClaimId,
  isSubmitting,
  isSaving,
  handleSaveConfirmationModal,
  isApprovedInitiated,
  uploadFileList,
  setIsAmountModal,
  roomChargesOptions,
  consultationChargesOptions,
  implantListOptions,
  isFetchingRoomCharges,
  isFetchingConsultationCharges,
  isFetchingImplantList,
  billRequiredDocuments = [],
  claimExtraDocuments = [],
  onSupportingFileSelect,
  onViewSupportingDocument,
  onDownloadSupportingDocument,
  onDeleteSupportingDocument,
}) => {
  const [totalClaimedAmount, setTotalClaimedAmount] = useState<number>(0);
  const items = Form.useWatch("items", form);
  const { hasFunctionality } = useUserFunctionalities();
  const { auth, patients } = useSelector((state: RootState) => state);
  const [totalEchsRate, setTotalEchsRate] = useState<number>(0);
  const navigate = useNavigate();

  const [totalEchsRateRoomCharges, setTotalEchsRateRoomCharges] =
    useState<number>(0);
  const [
    totalEchsRateConsultationCharges,
    setTotalEchsRateConsultationCharges,
  ] = useState<number>(0);
  const [totalEchsImplantCharges, setTotalEchsImplantCharges] =
    useState<number>(0);
  const [totalEchsProcedureCharges, setTotalEchsProcedureCharges] =
    useState<number>(0);

  const [totalClaimedAmountRoomCharges, setTotalClaimedAmountRoomCharges] =
    useState<number>(0);
  const [
    totalClaimedAmountConsultationCharges,
    setTotalClaimedAmountConsultationCharges,
  ] = useState<number>(0);
  const [
    totalClaimedAmountImplantCharges,
    setTotalClaimedAmountImplantCharges,
  ] = useState<number>(0);
  const [
    totalClaimedAmountUnlistedProcedure,
    setTotalClaimedAmountUnlistedProcedure,
  ] = useState<number>(0);
  const [totalClaimedAmountProcedure, setTotalClaimedAmountProcedure] =
    useState<number>(0);

  const implantList = Form.useWatch("implantList", form);
  const consultationList = Form.useWatch("consultationList", form);
  const roomChargesList = Form.useWatch("roomChargesList", form);
  const unlistedProcedureList = Form.useWatch("unlistedProcedureList", form);

  const amountReceivedFromPatient = Form.useWatch(
    "amountReceivedFromPatient",
    form,
  );
  const discount = Form.useWatch("discount", form);

  const otherCharges = Form.useWatch("otherCharges", form);
  const pharmacyAndConsumableCharges = Form.useWatch(
    "pharmacyAndConsumableCharges",
    form,
  );
  const [isClaimedAmountManual, setIsClaimedAmountManual] = useState(false);

  const sectionCollapseStyle = React.useMemo(
    () => ({
      border: "1px solid lightgray",
      borderRadius: "20px",
      marginBottom: "0.8rem",
      background: "#F2F6F9",
      padding: "2px 14px",
    }),
    [],
  );

  useEffect(() => {
    if (claimData) {
      form.setFieldsValue({
        // claimNo: claimData.claimNo || "",
        dateOfAdmission: claimData.dateOfAdmission
          ? dayjs(claimData.dateOfAdmission, "DD-MM-YYYY HH:mm:ss")
          : null,
        claimedAmount: claimData.claimedAmount || "",
        // otherHospitalExpenses: claimData.otherHospitalExpenses || "",
        billDate: claimData.billDate
          ? dayjs(claimData.billDate, ["DD-MM-YYYY HH:mm:ss", "DD/MM/YYYY"])
          : null,
        // billAmount: claimData.billAmount || "",
        billNumber: claimData.billNumber || "",
        remarks: claimData.remarks || "Claim Submitted" || "",
        treatingDoctorName: claimData.treatingDoctorName || "",
        natureOfAilment: claimData.natureOfAilment || "",
        diagnosisList: claimData.diagnosisList || [],
        // roomChargesList: claimData.roomChargesList || [],
        // consultationList: claimData.consultationList || [],
        // implantList: claimData.implantList || [],
        // unlistedProcedureList: claimData.unlistedProcedureList || [],
      });
    }
  }, [claimData, form]);

  useEffect(() => {
    const total = items?.reduce((sum: number, item: any) => {
      return sum + (parseFloat(item?.hospitalAmount) || 0);
    }, 0);
    setTotalClaimedAmountProcedure(total);
  }, [items]);

  useEffect(() => {
    const total = items?.reduce((sum: number, item: any) => {
      return sum + (parseFloat(item?.admissibleRate) || 0);
    }, 0);
    setTotalEchsProcedureCharges(total);
  }, [items]);

  //   useEffect(() => {
  //   const total = (items || [])?.reduce((sum: number, item: any) => {
  //     if (item?.active === false) return sum;
  //     return sum + (parseFloat(item?.hospitalAmount) || 0);
  //   }, 0);
  //   setTotalClaimedAmountProcedure(total);
  // }, [items]);

  // useEffect(() => {
  //   const total = (items || [])?.reduce((sum: number, item: any) => {
  //     if (item?.active === false) return sum;
  //     return sum + (parseFloat(item?.admissibleRate) || 0);
  //   }, 0);
  //   setTotalEchsProcedureCharges(total);
  // }, [items]);

  useEffect(() => {
    const calculateTotalForList = (list: any[], amountField: string) => {
      return list?.reduce((sum: number, item: any) => {
        if (item.active !== false) {
          return sum + (parseFloat(item?.[amountField]) || 0);
        }
        return sum;
      }, 0);
    };

    setTotalClaimedAmountRoomCharges(
      calculateTotalForList(roomChargesList, "hospitalAmount"),
    );

    setTotalClaimedAmountConsultationCharges(
      calculateTotalForList(consultationList, "hospitalAmount"),
    );

    setTotalClaimedAmountImplantCharges(
      calculateTotalForList(implantList, "hospitalAmount"),
    );

    setTotalClaimedAmountUnlistedProcedure(
      calculateTotalForList(unlistedProcedureList, "totalAmount"),
    );
  }, [roomChargesList, consultationList, implantList, unlistedProcedureList]);

  //Room charges
  useEffect(() => {
    const total = roomChargesList?.reduce((sum: number, item: any) => {
      if (item?.active === false) return sum;
      return sum + (parseFloat(item?.cghsRate) || 0);
    }, 0);
    setTotalEchsRateRoomCharges(total);
  }, [roomChargesList]);

  //Consultation charges
  useEffect(() => {
    const total = consultationList?.reduce((sum: number, item: any) => {
      if (item?.active === false) return sum;
      return sum + (parseFloat(item?.cghsRate) || 0);
    }, 0);
    setTotalEchsRateConsultationCharges(total);
  }, [consultationList]);

  //Implant charges
  useEffect(() => {
    const total = implantList?.reduce((sum: number, item: any) => {
      if (item?.active === false) return sum;
      return sum + (parseFloat(item?.cghsRate) || 0);
    }, 0);
    setTotalEchsImplantCharges(total);
  }, [implantList]);

  //Unlisted Procedure charges
  useEffect(() => {
    if (totalClaimedAmount > 5000) {
      setIsAmountModal(true);
    }
  }, [totalClaimedAmount]);

  useEffect(() => {
    const safeNumber = (value: any) =>
      isNaN(parseFloat(value)) || !value ? 0 : parseFloat(value);

    const total =
      safeNumber(totalClaimedAmountRoomCharges) +
      safeNumber(totalClaimedAmountConsultationCharges) +
      safeNumber(totalClaimedAmountImplantCharges) +
      safeNumber(totalClaimedAmountUnlistedProcedure) +
      safeNumber(otherCharges) +
      safeNumber(pharmacyAndConsumableCharges) +
      safeNumber(totalClaimedAmountProcedure) -
      safeNumber(amountReceivedFromPatient) -
      safeNumber(discount);

    setTotalClaimedAmount(total);
    if (isClaimedAmountManual) form.setFieldsValue({ claimedAmount: total });
    else form.setFieldsValue({ claimedAmount: claimData?.claimedAmount });
  }, [
    form,
    totalClaimedAmountConsultationCharges,
    totalClaimedAmountImplantCharges,
    totalClaimedAmountProcedure,
    totalClaimedAmountRoomCharges,
    totalClaimedAmountUnlistedProcedure,
    amountReceivedFromPatient,
    discount,
    otherCharges,
    pharmacyAndConsumableCharges,
    isClaimedAmountManual,
  ]);

  const validateClinicalAndTreatmentYes = () => {
    const clinical: Record<string, any> =
      form.getFieldValue("patientClinicalFindings") || {};
    const treatment: Record<string, any> =
      form.getFieldValue("lineOfTreatmentData") || {};

    const hasAtLeastOneYes = (obj: Record<string, any>) =>
      Object.entries(obj)
        ?.filter(([key]) => !String(key).endsWith("Value"))
        ?.some(
          ([, val]) =>
            typeof val === "string" && val?.toLowerCase().includes(":y"),
        );

    const clinicalOk = hasAtLeastOneYes(clinical);
    const treatmentOk = hasAtLeastOneYes(treatment);

    if (!clinicalOk) {
      errorMessageModal("Atleast single Patient Clinical Findings is mandatory.");
      return false;
    }

    if (!treatmentOk) {
      errorMessageModal("Atleast single Patient Line of Treatment is mandatory.");
      return false;
    }
    return true;
  };

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={() => {
          const safeNumber = (value: any) =>
            isNaN(parseFloat(value)) || !value ? 0 : parseFloat(value);

          const sumList = (list: any[], key: string) =>
            (list || [])?.reduce(
              (sum, item) => sum + safeNumber(item?.[key]),
              0,
            );

          const total =
            sumList(form.getFieldValue("items"), "hospitalAmount") +
            sumList(form.getFieldValue("roomChargesList"), "hospitalAmount") +
            sumList(form.getFieldValue("consultationList"), "hospitalAmount") +
            sumList(form.getFieldValue("implantList"), "hospitalAmount") +
            safeNumber(form.getFieldValue("otherCharges")) +
            safeNumber(form.getFieldValue("pharmacyAndConsumableCharges")) +
            sumList(
              form.getFieldValue("unlistedProcedureList"),
              "totalAmount",
            ) -
            safeNumber(form.getFieldValue("amountReceivedFromPatient")) -
            safeNumber(form.getFieldValue("discount"));

          setTotalClaimedAmount(total);
          form.setFieldsValue({ claimedAmount: total });
        }}
        // onValuesChange={() => {
        //   // Recalculate total amount when form values change
        //   const items = form.getFieldValue("items") || [];
        //   const total = items.reduce((sum: number, item: any) => {
        //     return sum + (parseFloat(item?.hospitalAmount) || 0);
        //   }, 0);
        //   setTotalClaimedAmount(total);
        // }}
      >
        <div className="emergency-section">
          <Collapse
            // defaultActiveKey={["1"]}
            expandIconPosition="start"
            style={sectionCollapseStyle}
          >
            <Panel
              header={
                <div
                  style={{
                    textDecoration: "underline",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  PATIENT DETAILS
                </div>
              }
              key="1"
            >
              <PatientDetails form={form} />
            </Panel>
          </Collapse>
        </div>

        {patients?.fetchBasicDetails?.referralInfoResponse?.echsReferralResponse
          ?.id ? (
          <ReferralDetailsEchs form={form} />
        ) : (
          <></>
        )}

        <BillDetails
          isEditable={isEditable}
          caseClaimSubmissionId={caseClaimSubmissionId}
        />

        {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
        "OP" ? (
          <></>
        ) : (
          <div className="emergency-section">
            <Collapse
              // defaultActiveKey={["1"]}
              expandIconPosition="start"
              style={sectionCollapseStyle}
            >
              <Panel
                header={
                  <div
                    style={{
                      textDecoration: "underline",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    Clinical Findings
                  </div>
                }
                key="1"
              >
                <EchsClaimClinicalFindings
                  form={form}
                  loading={loading}
                  disabled={portalSubmission}
                />
              </Panel>
            </Collapse>
          </div>
        )}

        {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
        "OP" ? (
          <></>
        ) : (
          <div className="emergency-section">
            <Collapse
              // defaultActiveKey={["1"]}
              expandIconPosition="start"
              style={sectionCollapseStyle}
            >
              <Panel
                header={
                  <div
                    style={{
                      textDecoration: "underline",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    Line Of Treatment
                  </div>
                }
                key="1"
              >
                <EchsClaimLineOfTreatment
                  form={form}
                  loading={loading}
                  disabled={portalSubmission}
                />
              </Panel>
            </Collapse>
          </div>
        )}

        <div className="expenses" style={{ background: "#F2F6F9" }}>
          <Collapse
            defaultActiveKey={["1"]}
            expandIconPosition="start"
            style={sectionCollapseStyle}
          >
            <Panel
              header={
                <div
                  style={{
                    textDecoration: "underline",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  EXPENSES FOR THE PATIENT (Room Charges, Consultation, Implant,
                  Etc.)
                </div>
              }
              key="1"
            >
              <EchsProcedureForm
                form={form}
                procedureDropDown={procedureDropDown}
                isEditable={isEditable}
                caseClaimSubmissionId={caseClaimSubmissionId}
                portalSubmission={portalSubmission}
                handleDeleteProcedure={handleDeleteProcedure}
                totalClaimedAmount={totalClaimedAmountProcedure}
                totalEchsRate={totalEchsProcedureCharges}
                onAmountChange={() => setIsClaimedAmountManual(true)}
              />
              <EchsExtraForm
                form={form}
                isEditable={isEditable}
                caseClaimSubmissionId={caseClaimSubmissionId}
                portalSubmission={portalSubmission}
                handleDeleteProcedure={handleDeleteProcedure}
                totalClaimedAmountRoomCharges={totalClaimedAmountRoomCharges}
                totalClaimedAmountConsultationCharges={
                  totalClaimedAmountConsultationCharges
                }
                totalClaimedAmountImplantCharges={
                  totalClaimedAmountImplantCharges
                }
                totalClaimedAmountUnlistedProcedure={
                  totalClaimedAmountUnlistedProcedure
                }
                totalEchsRateRoomCharges={totalEchsRateRoomCharges}
                totalEchsRateConsultationCharges={
                  totalEchsRateConsultationCharges
                }
                totalEchsImplantCharges={totalEchsImplantCharges}
                totalEchsRate={totalEchsRate}
                roomChargesOptions={roomChargesOptions}
                consultationChargesOptions={consultationChargesOptions}
                implantList={implantListOptions}
                onAmountChange={() => setIsClaimedAmountManual(true)}
                isFetchingRoomCharges={isFetchingRoomCharges}
                isFetchingConsultationCharges={isFetchingConsultationCharges}
                isFetchingImplantList={isFetchingImplantList}
              />

              <div
                style={React.useMemo(
                  () => ({
                    width: "100%",
                    marginBottom: "0.1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }),
                  [],
                )}
              >
                {/* <h4
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginRight: "2rem",
                  }}
                >
                  Total Echs Rate: ₹ {totalEchsRate || 0}/-
                </h4> */}

                <h4 style={{ display: "flex", justifyContent: "end" }}>
                  Total Amount: ₹ {totalClaimedAmount || 0}/-
                </h4>
              </div>
            </Panel>
          </Collapse>
        </div>
        <AdmissionDetails
          isEditable={isEditable}
          caseClaimSubmissionId={caseClaimSubmissionId}
          totalClaimedAmount={totalClaimedAmount}
          onAmountChange={() => setIsClaimedAmountManual(true)}
        />
        <AilmentDetails
          form={form}
          isEditable={isEditable}
          caseClaimSubmissionId={caseClaimSubmissionId}
          disabled={!isEditable}
        />
        {loading ? (
          <div
            style={{
              margin: "auto",
              width: "100%,",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          documentRequestResponseDocuments?.["requestedDocuments"]?.length >
            0 && (
            <DocumentUpload
              documentTypes={documentTypes}
              documentUrls={documentUrls}
              handleFileChange={handleFileChange}
              handleOpen={handleOpen}
              documentRequestResponseDocuments={
                documentRequestResponseDocuments
              }
              portalSubmission={portalSubmission}
              isApproved={isApproved}
              uploadFileList={uploadFileList}
              isIntimated={claimData?.intimated}
              isEchsScheme={true}
              billRequiredDocuments={billRequiredDocuments}
              claimExtraDocuments={claimExtraDocuments}
            />
          )
        )}

        {billRequiredDocuments?.length > 0 ? (
          <SupportingDocumentChecklistModal
            inlineMode
            documents={billRequiredDocuments}
            claimExtraDocuments={claimExtraDocuments}
            portalSubmission={portalSubmission}
            onCancel={() => null}
            onFileSelect={(doc, checkedItems, file) =>
              onSupportingFileSelect?.(doc, checkedItems, file)
            }
            onView={(record, documentUrl) =>
              onViewSupportingDocument?.(record, documentUrl)
            }
            onDownload={onDownloadSupportingDocument}
            onDelete={(record, documentUrl) =>
              onDeleteSupportingDocument?.(record, documentUrl)
            }
          />
        ) : null}

        {documentRequestResponseDocuments?.["responseDocuments"]?.length >
          0 && (
          <ResponseDocumentUpload
            documentTypes={documentTypes}
            documentUrls={documentUrls}
            handleFileChange={handleFileChange}
            handleOpen={handleOpen}
            portalSubmission={portalSubmission}
            documentRequestResponseDocuments={documentRequestResponseDocuments}
            handleSaveData={handleSaveData}
            currentStage={preAuth?.stepperData?.currentVisitStage}
            activeKey={activeKey}
            uploadFileList={uploadFileList}
          />
        )}
      </Form>
      <div className="buttons" style={{ margin: "16px 0" }}>
        {
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.8rem",
            }}
          >
            {claimData?.submitted || claimData?.initiated ? (
              // || claimData?.approved
              <></>
            ) : !caseClaimId ? (
              hasFunctionality("claimCreation") && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmit}
                    onClick={() => handleSaveConfirmationModal("save")}
                    loading={isSaving}
                  >
                    SAVE
                  </Button>
                </div>
              )
            ) : (
              hasFunctionality("claimCreation") &&
              !(auth?.role?.role == "FO_STAFF" && claimData?.intimated) && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmit}
                    onClick={() => handleSaveConfirmationModal("update")}
                    loading={isSaving}
                  >
                    Update
                  </Button>
                </div>
              )
            )}

            {hasFunctionality("claimIntimation") ? (
              claimData?.intimated ||
              claimData?.submitted ||
              claimData?.initiated ||
              claimData?.approved ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleIntimate}
                    onClick={() => handleSaveConfirmationModal("intimate")}
                    loading={isIntimating}
                  >
                    Send To QC
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}

            {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "OP" &&
              (hasFunctionality("opdBillList") ||
                hasFunctionality("ipdBillList")) && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      opacity: !isApproved ? 1 : 0.5,
                      pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    onClick={() =>
                      openBillAuditForMapping(
                        patients?.fetchBasicDetails?.visitInfoResponse
                          ?.billMappingId,
                        patients?.fetchBasicDetails?.casesResponse?.healthCareId,
                        patients?.fetchBasicDetails?.casesResponse?.schemeType,
                      )
                    }
                  >
                    Bill Audit
                  </Button>
                </div>
              )}

            {hasFunctionality("claimApprover") &&
              !claimData?.initiated &&
              !claimData?.approved &&
              !claimData?.submitted && (
                <div style={{ width: "16%" }}>
                  <Button
                    loading={isApprovedInitiated}
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      opacity: !isApproved ? 1 : 0.5,
                      pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    // onClick={handleApprove}
                    // onClick={() => handleSaveConfirmationModal("approve")}
                    // disabled={isApproved}
                    onClick={() => {
                      if (
                        patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() !==
                        "OP"
                      ) {
                        if (!validateClinicalAndTreatmentYes()) return;
                      }
                      // if (!validateClinicalAndTreatmentYes()) return;
                      handleSaveConfirmationModal("approve");
                    }}
                    disabled={isApproved}
                  >
                    Qc Approve
                  </Button>
                </div>
              )}

            {claimData?.submitted || claimData?.initiated ? (
              <></>
            ) : (
              hasFunctionality("claimSubmission") && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmitOnPortal}
                    // onClick={() => handleSaveConfirmationModal("submit")}
                    // loading={isSubmitting}
                    onClick={() => {
                      if (
                        patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() !==
                        "OP"
                      ) {
                        if (!validateClinicalAndTreatmentYes()) return;
                      }
                      // if (!validateClinicalAndTreatmentYes()) return;
                      handleSaveConfirmationModal("submit");
                    }}
                    loading={isSubmitting}
                  >
                    {patients?.fetchBasicDetails?.casesResponse
                      ?.integratedWithPortal
                      ? "Initiate"
                      : "Submit Manually"}
                  </Button>
                </div>
              )
            )}
          </div>
        }
      </div>
    </>
  );
};

export default React.memo(EchsClaimForm);
